import * as React from "react";
import { withRouter } from "react-router-dom";
import { getCarcinogenicTable, getProjectInfo } from "../../../apis/common";
import { checkProductd, checkDepthid } from '../../../configs/checkProductId'
import { getDepthid, getSessionNumberPlies, getSessionLevel, setSelectedKey, setDepthid, getSelectedKey } from '../../../utils/token'

import Header from './head';
import { Tabs, Row, Col, Form, Input, Divider, Tag, Table, Switch, Space, Spin, message } from "antd";
import './sensitivity.less'
import type { ColumnsType } from 'antd/es/table';
import strict from "assert/strict";
const { TabPane } = Tabs;
const { Column, ColumnGroup } = Table;
interface IProps {
  login: any;
  register: any;
  history: any;
  retrieve: any;
  location: any;
}
interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}
interface IState {
  depth_id: any,
  project_id: any,
  loading: boolean,
  CarcinogenicColumns: any,
  NotCarcinogenicColumns: any,
  cancolumns: any,
  Nocancolumns: any,
  candata: any,
  Nocandata: any,
  Number_Plies: any,
  waterCancerColumns: any;
  waterCancer: any;
  waterNotCancerColumns: any,
  waterNotCancer: any,
  soilCancerColumns: any,
  soilCancer: any,
  soilNotCancerColumns: any,
  soilNotCancer: any,
  headers: any,
  searchList: any,
  hasSearchList: boolean,
  adjustment: string;
  Level: any,
}


let soilCancerColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '中文名',
    dataIndex: 'name_cn',
    key: 'name_cn',
  },
  {
    title: '英文名',
    dataIndex: 'name_en',
    key: 'name_en',
    width: 200,
  },
  {
    title: 'CAS编号',
    dataIndex: 'cas_code',
    key: 'cas_code',
  },
  {
    title: '经口摄入土壤',
    dataIndex: 'OISERca',
    key: 'OISERca',
    children: [
      {
        title: 'OISERca',
        dataIndex: 'OISERca',
        key: 'IOVERca1',
      },
    ]
  },
  {
    title: '皮肤接触土壤',
    dataIndex: 'DCSERca',
    key: 'DCSERca',
    children: [
      {
        title: 'DCSERca',
        dataIndex: 'DCSERca',
        key: 'DCSERca',
      },
    ]
  },
  {
    title: '吸入土壤颗粒物',
    dataIndex: 'PIERca',
    key: 'PIERca',
    children: [
      {
        title: 'PIERca',
        dataIndex: 'PIERca',
        key: 'PIERca',
      },
    ]
  },
  {
    title: '吸入室外空气中来自表层土壤的气态污染物',
    dataIndex: 'IOVERca1',
    key: 'IOVERca1',
    children: [
      {
        title: 'IOVERca1',
        dataIndex: 'IOVERca1',
        key: 'IOVERca1',
      },
    ]
  },
  {
    title: '吸入室外空气中来自下层土壤的气态污染物',
    dataIndex: 'IOVERca2',
    key: 'IOVERca2',
    children: [
      {
        title: 'IOVERca2',
        dataIndex: 'IOVERca2',
        key: 'IOVERca2',
      },
    ]
  },
  {
    title: '吸入室内空气中来自下层土壤的气态污染物',
    dataIndex: 'IIVERca1',
    children: [
      {
        title: 'IIVERca1',
        dataIndex: 'IIVERca1',
        key: 'IIVERca1',
      },
    ]
  },
]
let soilNotCancerColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '中文名',
    dataIndex: 'name_cn'
  },
  {
    title: '英文名',
    dataIndex: 'name_en',
    width: 200,
  },
  {
    title: 'CAS编号',
    dataIndex: 'cas_code',
  },
  {
    title: '经口摄入土壤',
    dataIndex: 'OISERnc',
    children: [
      {
        title: 'OISERnc',
        dataIndex: 'OISERnc',
        key: 'OISERnc',
      },
    ]
  },
  {
    title: '皮肤接触土壤',
    dataIndex: 'DCSERnc',
    children: [
      {
        title: 'DCSERnc',
        dataIndex: 'DCSERnc',
        key: 'DCSERnc',
      },
    ]
  },
  {
    title: '吸入土壤颗粒物',
    dataIndex: 'PIERnc',
    children: [
      {
        title: 'PIERnc',
        dataIndex: 'PIERnc',
        key: 'PIERnc',
      },
    ]
  },
  {
    title: '吸入室外空气中来自表层土壤的气态污染物',
    dataIndex: 'IOVERnc1',
    children: [
      {
        title: 'IOVERnc1',
        dataIndex: 'IOVERnc1',
        key: 'IOVERnc1',
      },
    ]
  },
  {
    title: '吸入室外空气中来自下层土壤的气态污染物',
    dataIndex: 'IOVERnc2',
    children: [
      {
        title: 'IOVERnc2',
        dataIndex: 'IOVERnc2',
        key: 'IOVERnc2',
      },
    ]
  },
  {
    title: '吸入室内空气中来自下层土壤的气态污染物',
    dataIndex: 'IIVERnc1',
    children: [
      {
        title: 'IIVERnc1',
        dataIndex: 'IIVERnc1',
        key: 'IIVERnc1',
      },
    ]
  },
];
let waterCancerColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '中文名',
    dataIndex: 'name_cn'
  },
  {
    title: '英文名',
    dataIndex: 'name_en',
  },
  {
    title: 'CAS编号',
    dataIndex: 'cas_code',
  },
  {
    title: '吸入室外空气中来自地下水的气态污染物',
    dataIndex: 'IOVERca3',
    children: [
      {
        title: 'IOVERca3',
        dataIndex: 'IOVERca3',
      },
    ]
  },
  {
    title: '吸入室内空气中来自地下水的气态污染物',
    dataIndex: 'IIVERca2',
    children: [
      {
        title: 'IIVERca2',
        dataIndex: 'IIVERca2',
      },
    ]
  },
  {
    title: '饮用地下水',
    dataIndex: 'CGWERca',
    children: [
      {
        title: 'CGWERca',
        dataIndex: 'CGWERca',
      },
    ]
  },
];
let waterNotCancerColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '中文名',
    dataIndex: 'name_cn'
  },
  {
    title: '英文名',
    dataIndex: 'name_en',
  },
  {
    title: 'CAS编号',
    dataIndex: 'cas_code',
  },
  {
    title: '吸入室外空气中来自地下水的气态污染物',
    dataIndex: 'IOVERnc3',
    children: [
      {
        title: 'IOVERnc3',
        dataIndex: 'IOVERnc3',
      },
    ]
  },
  {
    title: '吸入室内空气中来自地下水的气态污染物',
    dataIndex: 'IIVERnc2',
    children: [
      {
        title: 'IIVERnc2',
        dataIndex: 'IIVERnc2',
      },
    ]
  },
  {
    title: '饮用地下水',
    dataIndex: 'CGWERnc 0',
    children: [
      {
        title: 'CGWERnc',
        dataIndex: 'CGWERnc',
      },
    ]
  },
];
class sensitivity extends React.PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      project_id: '',
      depth_id: '',
      Level: "",
      loading: true,
      CarcinogenicColumns: [],
      NotCarcinogenicColumns: [],
      candata: [],
      cancolumns: [],
      Nocandata: [],
      Nocancolumns: [],
      Number_Plies: [],
      waterCancerColumns: [],
      waterCancer: [],
      waterNotCancerColumns: [],
      waterNotCancer: [],
      soilCancerColumns: [],
      soilCancer: [],
      soilNotCancerColumns: [],
      soilNotCancer: [],
      searchList: [],//table数据源
      hasSearchList: false,
      adjustment: '20%',
      headers: [{
        dataIndex: 'columnHead',
        title: '参数名称',
        fixed: 'left',
        width: 100
      }, {
        dataIndex: 'whitespace',
        title: "参数含义",
        width: 100,
        fixed: 'left',

      }]//初始化headers


    };
  }
  gotoTap = async (step: string) => {
    if (step == 'back') {

      this.props.history.push({


        pathname: "/project/getlnitParamsValue",


      })


    }
    if (step == 'next') {
      let productId = checkProductd();
      console.log("SessionLevelSessionNumberPlies", this.state.depth_id,);

      console.log("this.state.Number_Plies", this.state.Number_Plies);
      getProjectInfo({
        project_id: productId
      }).then((res: any) => {
        console.log("res", res.data[0].depthRow);
        let depthRowArrays = res.data[0].depthRow
        let tier = 0
        let tierone = 0
        let depthId = 0
        let depthRowArraysdepthId = 0
        let indexs = 0
        let depthIdlength = depthRowArrays[depthRowArrays.length - 1].depth_id
        let Numberstr = Number(this.state.Number_Plies) + 1
        let depth_idstr = Number(this.state.depth_id) + 1
        let depth_idtoString = JSON.stringify(depth_idstr)


        depthRowArrays.forEach((items: any, indexs: any) => {
          // console.log("items", items.depth_id, items.tier, indexs);
          tierone = Number(items.tier) + 1
          tier = Number(items.tier)
          depthId = Number(items.depth_id)
          indexs = Number(indexs)




        })
        if (res.data[0].depthRow.length==1) {
       
          setSelectedKey('100')

          setTimeout(() => {
            this.props.history.push({


              pathname: "/project/generalReport",
              setSelect: '100',


            })
            window.location.reload()
          }, 200)
          
        }else{
          for (let index = 0; index < depthRowArrays.length; index++) {
            if (depthRowArrays[index].depth_id == this.state.depth_id) {
              console.log("depthRowArrays[index].depth_id1111111", depthRowArrays[index + 1].depth_id, this.state.depth_id, depthId);
              depthRowArraysdepthId = depthRowArrays[index + 1].depth_id
  
              console.log("index", this.state.depth_id, depthRowArraysdepthId, depthId);
  
              if (depthRowArraysdepthId == depthId) {
                console.log("depthRowArraysdepthId1111111", depthRowArraysdepthId, depthId);
               
                if (this.state.depth_id == depthId) {
                  setSelectedKey('100')
                  setTimeout(() => {
                    this.props.history.push({
  
  
                      pathname: "/project/generalReport",
                      setSelect: '100',
  
  
                    })
                    window.location.reload()
                  }, 200)
                }else{
                  let Number = this.state.Number_Plies + 1
                  setDepthid(JSON.stringify(depthId))
                  setSelectedKey(`${Numberstr + '-10'}`)
    
                  setTimeout(() => {
                    this.props.history.push({
    
                      pathname: "/project/followPollute",
                      val: `${Numberstr}`,
                      Depth: `${depthId}`,
    
                    })
                    window.location.reload()
                  }, 200)
                  return
                }
  
                return;
              } else {
                console.log("depthRowArraysdepthId2222222", depthRowArraysdepthId, depthId);
                let Number = this.state.Number_Plies + 1
                setDepthid(JSON.stringify(depthRowArraysdepthId))
                setSelectedKey(`${Numberstr + '-10'}`)
  
                setTimeout(() => {
                  this.props.history.push({
  
                    pathname: "/project/followPollute",
                    val: `${Numberstr}`,
                    Depth: `${depthRowArraysdepthId}`,
  
                  })
                  window.location.reload()
                }, 200)
                return
              }
  
            } else {
              console.log("depthRowArrays[index].depth_id22222222", depthRowArrays[index + 1].depth_id, this.state.depth_id, depthId);
              setSelectedKey('100')
              setTimeout(() => {
                this.props.history.push({
  
  
                  pathname: "/project/generalReport",
                  setSelect: '100',
  
  
                })
                window.location.reload()
              }, 200)
            }
  
  
          }

        }
    



        // if (this.state.depth_id == depthIdlength) {
        //   console.log("是", this.state.depth_id, depthIdlength);


        // } else {

        //   let Number = this.state.Number_Plies + 1
        //   // setDepthid(depth_idtoString)
        //   setSelectedKey(`${Numberstr + '-10'}`)

        //   setTimeout(() => {
        //     // this.props.history.push({

        //     //   pathname: "/project/followPollute",
        //     //   val: `${Numberstr}`,
        //     //   Depth: `${depth_idstr}`,

        //     // })
        //     // window.location.reload()
        //   }, 200)

        // }


      }).catch((err: any) => {
        // message.warn('服务器异常，请稍后再试')
      })


    }
  }
  componentWillMount() {
    let route = this.props.history.location;
    console.log("this.props", route.adjustment);

    if (route.adjustment) {
      console.log("11111");

      this.setState({
        adjustment: route.adjustment
      })
    }

    let productId = checkProductd();
    if (productId) {
      this.setState({
        project_id: productId
      })
    }
    let Depthid = checkDepthid();
    if (Depthid) {
      this.setState({
        depth_id: Depthid,
      })
    }
    let NumberPlies = getSessionNumberPlies();
    if (NumberPlies) {
      this.setState({
        Number_Plies: NumberPlies,
      })
    }
    let Level = getSessionLevel()
    if (Level) {
      this.setState({
        Level: Level,
      })
    }
  }
  componentDidMount() {
    this.exposedQuantityTable()

  }
  exposedQuantityTable = async () => {
    let params = {
      project_id: this.state.project_id,
      depth_id: this.state.depth_id,
      // adjustment_coefficient: '1%'
      adjustment_coefficient: this.state.adjustment
    }
    try {
      let res = await getCarcinogenicTable(params);
      console.log("res", res);
      let Waterexposure = res.data.risk.water;
      let Soilexposure = res.data.risk.soil;

      this.setState({
        loading: false
      })
      this.handlewater(Waterexposure)
      this.handlesoil(Soilexposure)
    } catch (error) {
      message.warn('服务器异常，请稍后再试')
      console.log("error", error);

      this.props.history.push({


        pathname: "/project/getlnitParamsValue",


      })
    }
  }
  handlewater = (exposure: any) => {
    let { cancer: waterCancer, not_cancer: waterNotCancer } = exposure;
    this.handleWaterCancer(waterCancer)
    this.handleWaterNotCancer(waterNotCancer)
  }

  handlesoil = (exposure: any) => {
    let { cancer: soilCancer, not_cancer: soilNotCancer } = exposure;
    this.handleSoilCancer(soilCancer)
    this.handleSoilNotCancer(soilNotCancer)
  }

  // --- 核心修复部分：明确 columns 类型为 any[] 解决 TS2345 错误 ---

  handleWaterCancer = (data: any) => {
    if (!data || data.length === 0) return;
    // 关键：明确声明为 any[]
    let columns: any[] = [
      { title: '参数名称', dataIndex: 'name_en', key: 'name_en', fixed: 'left', width: 100 },
      { title: '参数含义', dataIndex: 'name_cn', key: 'name_cn', fixed: 'left', width: 120 },
    ];
    data.forEach((pollutant: any) => {
      columns.push({
        title: pollutant.name_cn,
        dataIndex: `col_${pollutant.id}`,
        key: `col_${pollutant.id}`,
        width: 150,
      });
    });
    const dataSource = data[0].item.map((template: any, index: number) => {
      let row: any = { id: index, name_en: template.name_en, name_cn: template.name_cn };
      data.forEach((pollutant: any) => {
        row[`col_${pollutant.id}`] = pollutant.item[index]?.sensitivity;
      });
      return row;
    });
    this.setState({ waterCancerColumns: columns, waterCancer: dataSource });
  }

  handleWaterNotCancer = (data: any) => {
    if (!data || data.length === 0) return;
    let columns: any[] = [
      { title: '参数名称', dataIndex: 'name_en', key: 'name_en', fixed: 'left', width: 100 },
      { title: '参数含义', dataIndex: 'name_cn', key: 'name_cn', fixed: 'left', width: 120 },
    ];
    data.forEach((pollutant: any) => {
      columns.push({ title: pollutant.name_cn, dataIndex: `col_${pollutant.id}`, key: `col_${pollutant.id}`, width: 150 });
    });
    const dataSource = data[0].item.map((template: any, index: number) => {
      let row: any = { id: index, name_en: template.name_en, name_cn: template.name_cn };
      data.forEach((pollutant: any) => {
        row[`col_${pollutant.id}`] = pollutant.item[index]?.sensitivity;
      });
      return row;
    });
    this.setState({ waterNotCancerColumns: columns, waterNotCancer: dataSource });
  }

  handleSoilCancer = (data: any) => {
    if (!data || data.length === 0) return;
    let columns: any[] = [
      { title: '参数名称', dataIndex: 'name_en', key: 'name_en', fixed: 'left', width: 100 },
      { title: '参数含义', dataIndex: 'name_cn', key: 'name_cn', fixed: 'left', width: 120 },
    ];
    data.forEach((pollutant: any) => {
      columns.push({ title: pollutant.name_cn, dataIndex: `col_${pollutant.id}`, key: `col_${pollutant.id}`, width: 150 });
    });
    const dataSource = data[0].item.map((template: any, index: number) => {
      let row: any = { id: index, name_en: template.name_en, name_cn: template.name_cn };
      data.forEach((pollutant: any) => {
        row[`col_${pollutant.id}`] = pollutant.item[index]?.sensitivity;
      });
      return row;
    });
    this.setState({ soilCancerColumns: columns, soilCancer: dataSource });
  }

  handleSoilNotCancer = (data: any) => {
    if (!data || data.length === 0) return;
    let columns: any[] = [
      { title: '参数名称', dataIndex: 'name_en', key: 'name_en', fixed: 'left', width: 100 },
      { title: '参数含义', dataIndex: 'name_cn', key: 'name_cn', fixed: 'left', width: 120 },
    ];
    data.forEach((pollutant: any) => {
      columns.push({ title: pollutant.name_cn, dataIndex: `col_${pollutant.id}`, key: `col_${pollutant.id}`, width: 150 });
    });
    const dataSource = data[0].item.map((template: any, index: number) => {
      let row: any = { id: index, name_en: template.name_en, name_cn: template.name_cn };
      data.forEach((pollutant: any) => {
        row[`col_${pollutant.id}`] = pollutant.item[index]?.sensitivity;
      });
      return row;
    });
    this.setState({ soilNotCancerColumns: columns, soilNotCancer: dataSource });
  }
  render() {


    return (
      <div className="content">
        <Spin spinning={this.state.loading}>

          <Tabs
            type="card"
            defaultActiveKey='1'
            onChange={(key) => {
              console.log(key);
            }}
          >
            <TabPane tab="土壤" key="1">
              <div className="setting">
                <div className="modeliconleft">土壤敏感性比（致癌）</div>
              </div>
              <Divider></Divider>

              <Table
                columns={this.state.soilCancerColumns}
                dataSource={this.state.soilCancer}
                rowKey={record => record.id}
                scroll={{ x: 1500 }}
                bordered
                loading={false}
              >
              </Table>
              <div className="setting">
                <div className="modeliconleft">土壤敏感性比（非致癌效应）</div>
              </div>
              <Divider></Divider>
              <Table
                columns={this.state.soilNotCancerColumns}
                dataSource={this.state.soilNotCancer}
                rowKey={record => record.id}
                scroll={{ x: 1500 }}
                bordered
              >
              </Table>
            </TabPane>

            <TabPane tab="地下水" key="2">
              <div className="setting">
                <div className="modeliconleft">地下水敏感性比（致癌）</div>
              </div>
              <Divider></Divider>
              <Table
                columns={this.state.waterCancerColumns}
                dataSource={this.state.waterCancer}
                rowKey={record => record.id}
                scroll={{ x: 1500 }}
                bordered
              >
              </Table>
              <div className="setting">
                <div className="modeliconleft">地下水敏感性比（非致癌效应）</div>
              </div>
              <Divider></Divider>
              <Table
                columns={this.state.waterNotCancerColumns}
                dataSource={this.state.waterNotCancer}
                rowKey={record => record.id}
                bordered
                scroll={{ x: 1500 }}
              >
              </Table>
            </TabPane>
          </Tabs>

          <div className="exposebtn">
            <button className="formbtnleft" onClick={this.gotoTap.bind(this, 'back')}>上一步</button>
            <button className="formbtnright" onClick={this.gotoTap.bind(this, 'next')}>下一步</button>
          </div>
        </Spin>
      </div >
    );
  }
}

export default withRouter(sensitivity);
